import { render, staticRenderFns } from "./StudyAreaMap.vue?vue&type=template&id=0803345a&scoped=true&"
import script from "./StudyAreaMap.vue?vue&type=script&lang=js&"
export * from "./StudyAreaMap.vue?vue&type=script&lang=js&"
import style0 from "./StudyAreaMap.vue?vue&type=style&index=0&id=0803345a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0803345a",
  null
  
)

export default component.exports